export enum MENU_ROUTES {
  HOME = 'home',
  PLAYBACK_RATE = 'playback_rate',
  RESOLUTION = 'resolution',
}
